module.exports = __webpack_public_path__ + "assets/media/day20.4d20e12f.mp3";